import { useConversionStore } from '@/pages/ISWAN_APP/hooks/useConversionStore/useConversionStore';
import NavDrawer, { NavDrawerRef } from '@/pages/ISWAN_APP/layout/NavDrawer/NavDrawer';
import { BellOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';
import { useRef } from 'react';
import s from './NavBar.less';

const NavBar = () => {
  const [aiType] = useModel('ISWAN_CHAT.aiType');
  const { setStoreConversationId } = useConversionStore();
  const navDrawer = useRef<NavDrawerRef>(null);

  function handleOpenDrawer() {
    if (navDrawer.current) {
      navDrawer.current.openDrawer();
    }
  }

  function handleNewChat() {
    setStoreConversationId();
  }

  return (
    <>
      <div className={s.main}>
        <div className={s.left}>
          <div className={s.drawerIcon} onClick={handleOpenDrawer}>
            <MenuUnfoldOutlined />
          </div>
          {!!aiType && (
            <div className={s.newChatBtn} onClick={handleNewChat}>
              <div className={s.newChatBtn_plus}>+</div>
              <div className={s.newChatBtn_text}>新对话</div>
            </div>
          )}
        </div>
        <div className={s.center}> </div>
        <div className={s.right}>
          {/*<div className={s.version}>标准版</div>*/}

          {/*<div className={s.alerm}>*/}
          {/*  <BellOutlined />*/}
          {/*</div>*/}
        </div>
      </div>
      <div className={s.main_pl} />

      <NavDrawer ref={navDrawer} />
    </>
  );
};

export default NavBar;
